import { Expose } from 'class-transformer'

export class CategoryOptionType {
  @Expose({ name: 'id' }) value: number

  @Expose({ name: 'name' }) label: string
}
